import { connect } from 'react-redux';

import { siteUrlsSelector } from '../../selectors/SiteUrlsSelectors';
import { AppState } from '../../state/AppState';
import { MapStateToProps } from '../../utils/ConnectUtils';
import { RecommendationsSpace, RecommendationsSpaceOwnProps, RecommendationsSpaceStateProps } from './RecommendationsSpace';

const mapStateToProps: MapStateToProps<RecommendationsSpaceStateProps> = (state: AppState) => ({
  urls: siteUrlsSelector(state)
});

export const ConnectedRecommendationsSpace: React.ComponentClass<RecommendationsSpaceOwnProps>
  = connect(mapStateToProps, {})(RecommendationsSpace);
